import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { cn } from "@/lib/utils"

interface RadioGroupItemProps extends React.ComponentPropsWithRef<typeof RadioGroupPrimitive.Item> {
  error?: boolean
}

export const RadioGroupItem = ({ className, children, error, ...props }: RadioGroupItemProps) => {
  return (
    <RadioGroupPrimitive.Item
      {...props}
      className={cn(
        "radio-item bg-surface text-on-surface hover:bg-surface-hovered focus:bg-surface-pressed focus:text-on-primary-surface focus-visible:outline-primary-focused flex h-8 w-full! cursor-pointer items-center justify-center gap-2 self-center rounded-md border p-4 focus:outline-hidden disabled:cursor-auto disabled:py-4.25",
        error && "radio-item--error",
        className,
      )}>
      {children}
    </RadioGroupPrimitive.Item>
  )
}
